import { SxProps } from "@mui/material";
import FormControlLabel from "@mui/material/FormControlLabel";
import Link from "@mui/material/Link";
import { FC } from "react";
import { v4 } from "uuid";

const style: SxProps = {
  paddingLeft: "5px",
};

const HTMLLink: FC<{
  value: string | undefined;
  label: string;
  href: string | undefined;
}> = ({ value, label, href }) => {
  return (
    <FormControlLabel
      control={
        <Link
          sx={{ ...style }}
          key={href}
          target="_blank"
          rel="noreferrer"
          href={href ? href : ""}
        >
          {value ? value : ""}
        </Link>
      }
      label={label}
      labelPlacement="start"
    />
  );
};

export default HTMLLink;
//HTMLLink.whyDidYouRender = true;
